import React from 'react';
import { useTranslation } from 'react-i18next';

const Location = () => {
    const { t } = useTranslation();

    return (
        <section id="location">
            <h2>{t('location_where')}</h2>
            <div className="location-details">
                <p>{t('location_address')}</p>
                <a href="https://www.google.com/maps/dir//Restaurante+Maloca,+Pol%C3%ADgono+Playa+de+los+Alemanes,+57,+30380+La+Manga,+Murcia" target="_blank" rel="noopener noreferrer" className="directions-button">
                    {t('location_how_to_get_there')}
                </a>
            </div>
        </section>
    );
};

export default Location;
